import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { getMutationFn } from '../../common/queryClient/getMutationFn';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import { OutputDataUrl } from './OutputDataUrl';
import { OutputTestValidationDetailsSchema } from '../schema/OutputTestValidationSchema';
import { ValidationRuleTestValidationType } from '../../dataobject';

export const postTestValidate = (params: ValidationRuleTestValidationType) =>
  apiClient
    .post<void>(expand(OutputDataUrl.TEST_VALIDATIONS, {}), params)
    .then((response) => OutputTestValidationDetailsSchema.parse(response.data));

export const useMutateTestValidateDagQuery = createApiMutationHook(
  ['outputTestValidate'],
  getMutationFn(postTestValidate),
);
